import {
  FETCHING_USER_TREENODES,
  FETCHED_USER_TREENODES,
} from '_reducers/treeNodes'


export const FETCHING_USER = 'FETCHING_USER'
export const FETCHED_USER = 'FETCHED_USER'
export const NO_LOGGED_USER = 'NO_LOGGED_USER'
export const EDIT_USER_DATA = 'EDIT_USER_DATA'
export const SAVE_USER_DATA = 'SAVE_USER_DATA'
export const SAVING_USER_DATA = 'SAVING_USER_DATA'
export const ERROR_SAVING_USER_DATA = 'ERROR_SAVING_USER_DATA'

const authInit = {
  isLogged: false,
  isFetching: false,
  isUpdatingData: false,
  user: {
    location: {
      country: null,
      region: null,
    },
    links: {},
  },
  treeNodes: {
    isFetching: false,
    data: [],
  }
}

export function auth(auth=authInit, action) {
  switch(action.type) {
    case SAVING_USER_DATA:
      return {
        ...auth,
        isUpdatingData: true,
      }
    case SAVE_USER_DATA:
      return {
        ...auth,
        isUpdatingData: false,
        user: {
          ...authNotSaved.user,
          ...action.data
        },
      }
    case ERROR_SAVING_USER_DATA:
      return {
        ...auth,
        isUpdatingData: false,
      }
    case FETCHING_USER:
      localStorage.removeItem('uocCredentials')
      return {
        ...auth,
        isFetching: true,
        isLogged: false,
        user: auth.user,
      }
    case FETCHED_USER:
      localStorage.setItem('uocCredentials', JSON.stringify(action.user.uocCredentials))
      return {
        ...auth,
        isUpdatingData: false,
        isFetching: false,
        isLogged: true,
        user: {
          ...action.user,
          url: action.user.url ? action.user.url : action.user.username,
        },
      }
    case NO_LOGGED_USER:
      localStorage.removeItem('uocCredentials')
      return {
        isFetching: false,
        isLogged: false,
        user: authInit.user,
        treeNodes: {
          isFetching: false,
          data: [],
        }
      }

    case FETCHING_USER_TREENODES:
      return {
        ...auth,
        treeNodes: {
          isFetching: true,
          data: [],
        }
      }
    case FETCHED_USER_TREENODES:
      return {
        ...auth,
        treeNodes: {
          isFetching: false,
          data: action.treeNodes,
        }
      }
    default:
      return auth
  }
}


export function authNotSaved(authNotSaved=authInit, action) {
  switch(action.type) {
    case EDIT_USER_DATA:
      return {
        ...authNotSaved,
        user: {
          ...authNotSaved.user,
          ...action.data
        },
      }
    case FETCHED_USER:
      return {
        ...authNotSaved,
        user: {
          ...action.user,
          url: action.user.url ? action.user.url : action.user.username,
        }
      }
    default:
      return authNotSaved
  }
}
